<template>
  <div class="body">
    <div class="section wf-section"></div>
    <div class="section-2 last wf-section">
      <div class="container w-container">
        <!-- <p class="paragraph"> -->
        <!-- <iframe id="8d508ca0-14d8-37dd-44bf-6b3901d8be04-live-68b25716-c475-61ee-5942-c3fd73b6db75"
          src="https://iframe.dacast.com/live/8d508ca0-14d8-37dd-44bf-6b3901d8be04/68b25716-c475-61ee-5942-c3fd73b6db75"
          width="100%" height="100%" frameborder="0" scrolling="no" allow="autoplay;encrypted-media" allowfullscreen
          webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen
          style="position:absolute;top:0;left:0; object-fit: cover;"></iframe> -->

        <!-- <video preload="auto" playsinline="" webkit-playsinline=""
          style="display: block; width: 100%; height: 100%; pointer-events: none;" disableremoteplayback=""
          src="https://iframe.dacast.com/162647a6-56fb-4031-b339-dd6f945c7f6b"></video> -->


        <div class="arbitrarily-placed-and-sized-parent-element">
          <div class="video-embed-object-fit-cover">
            <div id="dcPlayer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  mounted() {
    let dacastScript = document.createElement('script')
    dacastScript.setAttribute('src', 'https://player.dacast.com/js/player.js?contentId=8d508ca0-14d8-37dd-44bf-6b3901d8be04-live-68b25716-c475-61ee-5942-c3fd73b6db75')
    document.head.appendChild(dacastScript)

    window.addEventListener("load", function () {
      var CONTENT_ID = "8d508ca0-14d8-37dd-44bf-6b3901d8be04-live-68b25716-c475-61ee-5942-c3fd73b6db75"
      window.dacast(CONTENT_ID, 'dcPlayer', {
        player: 'html5hls',
        // width: 800,
        // height: 600
      });
    });
  }
}
</script>

<style>
/* 
  Arbitrarily sized & positioned element that will 
  contain the embedded video as background.
*/
.arbitrarily-placed-and-sized-parent-element {
  position: relative;
  top: 0px;
  left: 0px;

  width: 100vw;
  height: calc(100vh - 70px);
}

/*
  This element contains the iframe, will take it's size from
  it's parent and will behave like an image/video 
  with object-fit: cover.
*/
.video-embed-object-fit-cover {
  position: absolute;

  /* ensure positioning regardless of parent flex settings */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  width: 100%;
  height: 100%;

  /* important */
  container-type: size;

  /* cut off overflowing video */
  overflow: hidden;
}

.video-embed-object-fit-cover>iframe {
  position: absolute;
  /* keep video centered both vertically and horizontally */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 100%;
  height: 100%;

  /* force aspect ratio based on parent container */
  @container (min-aspect-ratio: 16/9) {
    height: 56.25cqw;
    /* 100*9/16 */
  }

  @container (max-aspect-ratio: 16/9) {
    width: 177.78cqh;
    /* 100*16/9 */
  }

  /* prevent interaction */
  /* pointer-events: none; */
}
</style>